import { css } from '@emotion/react';
import { gray5, primary } from 'styles/global_defaults/colors';
import {
  headerLineHeight,
  headerRegularLineHeight,
  textLargeLineHeight,
} from 'styles/global_defaults/fonts';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';

/**
 * Returns modal body styles for the AI role-play config modal.
 *
 * @param step - Configuration step for the modal layout.
 *   - 1: Initial configuration step (compact layout, no side padding).
 *   - 2: Subsequent step(s) (side padding; height is bounded by the scrollable
 *        .bs4-modal-body set up in index.tsx, not by this wrapper).
 */

type Step = 1 | 2;
export const getModalBodyStyles = (step: Step) => css`
  height: fit-content;
  padding-left: ${step === 1 ? '0' : '140px'};
  padding-right: ${step === 1 ? '0' : '140px'};

  .situation-textarea {
    position: relative;
    border-radius: ${quarterSpacing}px;
    width: 100%;
    background-color: transparent; /* Transparent by default */
    transition: background-color 0.3s; /* Smooth transition for hover effect */
    z-index: 0; /* Ensure the .gradient-btn is on top */
    textarea {
      background: transparent;
      border: 0px;
      box-shadow: none;
      width: 100%;
    }

    ::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: inherit; /* Ensure the border radius is applied */
      padding: 1px; /* Adjust to match the border width */
      background: linear-gradient(to left, #009ac0, #00ccbc, #60f3ab);
      -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: destination-out;
      mask-composite: exclude; /* Make the center part transparent */
      z-index: -1;
    }
  }
`;

export const sharedStyles = css`
  .min-h-sm {
    min-height: 45px;
  }
  .min-h-lg {
    min-height: 140px;
  }
  .lh-35 {
    line-height: ${headerRegularLineHeight}px !important;
  }
  .lh-30 {
    line-height: ${textLargeLineHeight}px !important;
  }
  .lh-25 {
    line-height: ${headerLineHeight}px !important;
  }

  textarea:hover:not(:focus) {
    cursor: pointer !important;
    overflow-y: auto;
  }

  .required-textarea {
    .nv-text-area {
      box-shadow: 0 0 0 1px ${gray5};
      border-radius: ${quarterSpacing}px;
      &:focus-within {
        box-shadow: 0 0 0 1px ${primary};
      }
      textarea {
        background: transparent;
        border: none;
        box-shadow: none;
        outline: none;
      }
      .bs4-input-group-text {
        align-items: flex-start;
        background: transparent;
        border: none;
        margin: 1px;
      }
    }
  }

  .required-input {
    height: 45px;
    border-radius: ${quarterSpacing}px;
    box-shadow: 0 0 0 1px ${gray5};
    &:focus-within {
      box-shadow: 0 0 0 1px ${primary};
    }
    .nv-text-input {
      height: 100%;
      display: flex;
      align-items: center;
      border: none;
      input {
        height: 100%;
        background-color: transparent;
        border: none;
      }
      .input-required {
        .bs4-input-group-text {
          background-color: transparent;
          border: none;
          margin: 1px;
        }
      }
    }
  }
`;

